var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-sign-notes-form',{staticClass:"pt-sign-notes-form__page",attrs:{"isEdit":_vm.is_edit,"id":_vm.id,"noteId":_vm.noteId}})}
var staticRenderFns = []

export { render, staticRenderFns }